import React from 'react';

const MaintenancePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <svg
              className="mx-auto h-12 w-12 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
              Maintenance in Progress
            </h2>
            <p className="mt-4 text-sm text-gray-600">
              We're currently performing maintenance to improve our systems. We apologise for any inconvenience.
            </p>
            {/* <p className="mt-2 text-sm text-gray-600">
              The Portal will be back online soon.
            </p> */}
            <div className="mt-6 border-t border-gray-200 pt-6">
              <p className="text-xs text-gray-500">
                Expected completion: <i>within 24 hours</i>
              </p>
              <p className="mt-2 text-xs text-gray-500">
                For urgent support, please use our customer support system by clicking the green icon at the bottom right of the page.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
